/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The `mime-types` returned or sent as an `Accept` header.
 */
export type RdSAPAssessmentReportMimeTypes = 'application/xml' | 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui' | 'application/json+RdSAP-Summary';

export const RdSAPAssessmentReportMimeTypes = {
    Xml: 'application/xml' as RdSAPAssessmentReportMimeTypes,
    XmlRdSapSchema2000: 'application/xml+RdSAP-Schema-20.0.0' as RdSAPAssessmentReportMimeTypes,
    JsonRdSapQuidosUi: 'application/json+RdSAP-quidos-ui' as RdSAPAssessmentReportMimeTypes,
    JsonRdSapSummary: 'application/json+RdSAP-Summary' as RdSAPAssessmentReportMimeTypes
};

